import { render, staticRenderFns } from "./EditorCrud.vue?vue&type=template&id=10242ca5&scoped=true&lang=pug&"
import script from "./EditorCrud.vue?vue&type=script&lang=js&"
export * from "./EditorCrud.vue?vue&type=script&lang=js&"
import style0 from "./EditorCrud.vue?vue&type=style&index=0&id=10242ca5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10242ca5",
  null
  
)

export default component.exports